import {
  ApiResponse,
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "@/data/apiClient";
import { Client, ClientConfig } from "@/assets/js/constants";

export const getClients = async (
  p = {
    includeChildren: undefined as boolean | undefined,
    hideInactive: undefined as boolean | undefined,
  }
): Promise<ApiResponse<Client[]>> => getRequest("clients", p);

export const getSubClients = async (
  parentKey: string
): Promise<ApiResponse<Client[]>> => getRequest("clientsChildren", { parentKey });

export const getClientDetails = async (
  clientKey: string
): Promise<ApiResponse<Client>> => getRequest("client", { clientKey });

export const getClientConfig = async (
  key: string
): Promise<ApiResponse<ClientConfig>> =>
  getRequest("clientConfig", { key, asText: true });

export const updateClientDetails = async (
  client: Client
): Promise<ApiResponse<Client>> => putRequest("client", client);

export const updateClientConfig = async (
  clientConfig: ClientConfig
): Promise<ApiResponse<ClientConfig>> =>
  postRequest("clientConfig", clientConfig);

export const createClient = async (
  client: Client
): Promise<ApiResponse<Client>> => postRequest("client", client);

export const deleteClient = async (key: string): Promise<ApiResponse<Client>> =>
  deleteRequest("client", { key });
